
<div class="row">
  @if(this.isCompany == true) {
  }
  <!-- <ng-template ngbNavContent> -->
    @if (gotDgProperties) {
      <app-grid-view #gridView
        [apiPath]="dgApiPath"
        [dgActionColumn]="dgActionColumn"
        [dgColumns]="dgColumns"
        [dgPopup]="dgPopup"
        [dgProperties]="dgProperties"
        [dgTabs]="dgTabs"
        (addButtonClick)="gridAddButtonClick($event)"
        (cellClick)="cellClick($event)"
        (checkbox0Change)="onCheckboxChange($event)"
        (contentReady)="gridContentReady()"
        (moreButtonClick)="gridMoreButtonClick($event)"
        (tabChanged)="onTabChange($event)"
      ></app-grid-view>
    }
  <!-- </ng-template> -->
</div>

<app-company-modal-form #companyModalForm
  (companyFormCancelled)="companyFormHasBeenCancelled()"
  (sureSimCompanyDataHasBeenSaved)="companyDataHasBeenSaved()"
></app-company-modal-form>

<app-user-modal-form #userModalForm
  (sureSimUserDataHasBeenSaved)="userFormHasBeenSaved()"
  (userFormCancelled)="userFormHasBeenCancelled()"
></app-user-modal-form>

<app-manage-esim-modal-form #manageEsimModalForm
  (orderDataHasBeenSaved)="orderDataHasBeenSaved()"
  (eSimManagerFormCancelled)="manageEsimFormHasBeenCancelled()"
></app-manage-esim-modal-form>

<app-ticket-modal-form #ticketModalForm
  (ticketFormCancelled)="ticketFormHasBeenCancelled()"
  (ticketFormHasBeenSaved)="ticketFormHasBeenSaved()"
  [initialInviewCompanyId]="curUserInviewCompanyID"
></app-ticket-modal-form>

<app-add-ticket-note-modal-form #ticketNotesModalForm
  (ticketNoteFormCancelled)="ticketNoteFormHasBeenCancelled()"
  (ticketNoteFormHasBeenSaved)="ticketNoteFormHasBeenSaved()"
></app-add-ticket-note-modal-form>

<app-information-modal-form #informationModalForm
></app-information-modal-form>
